import $ from "jquery";
import Flickity from "flickity";
import "../vendors/flickity-imagesloaded/flickity-imagesloaded.js";

class FrontPageHorsesSlider {
	constructor($el) {
		this.$el = $el;

		this.options = {
			autoPlay:false,
			pageDots: false,
			wrapAround: true,
			prevNextButtons: true,
			freeScroll: true,
            cellAlign: 'center',
			cellSelector: ".horse-list__link",
            arrowShape: { 
                x0: 10,
                x1: 60, y1: 50,
                x2: 70, y2: 40,
                x3: 30
            },
		};

		if (this.$el.length) {
            this._init();
            this._resize();
            this._bindEvents();
		}
	}

    _init() {
        this.$slides = this.$el.find('.horse-list__link');
        this.slidesCount = this.$slides.length;

        if(this.slidesCount > 0) {
            this._createSlider();
        }
    }

    _bindEvents() {
        document.addEventListener('webfont:loaded', this._resize.bind(this));
    }

	_createSlider() {
        this.slider = new Flickity(this.$el[0], this.options);
    }

    _resize() {
        if(this.slider) {
            this.slider.resize();
        }
    }
}

export default FrontPageHorsesSlider;